__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ecommerce-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@react-oauth/google", "0.13.4", () => (Promise.all([__webpack_require__.e(925), __webpack_require__.e(447)]).then(() => (() => (__webpack_require__(5447))))));
			register("@stomp/stompjs", "1.0.0", () => (__webpack_require__.e(168).then(() => (() => (__webpack_require__(7168))))));
			register("axios", "1.13.6", () => (__webpack_require__.e(344).then(() => (() => (__webpack_require__(4344))))));
			register("framer-motion", "12.38.0", () => (Promise.all([__webpack_require__.e(14), __webpack_require__.e(925), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(5014))))));
			register("i18next-browser-languagedetector", "8.2.1", () => (__webpack_require__.e(848).then(() => (() => (__webpack_require__(1848))))));
			register("i18next", "25.8.18", () => (__webpack_require__.e(978).then(() => (() => (__webpack_require__(4978))))));
			register("idb", "8.0.3", () => (__webpack_require__.e(421).then(() => (() => (__webpack_require__(5421))))));
			register("jwt-decode", "4.0.0", () => (__webpack_require__.e(420).then(() => (() => (__webpack_require__(4420))))));
			register("leaflet", "1.9.4", () => (__webpack_require__.e(228).then(() => (() => (__webpack_require__(228))))));
			register("react-dom", "19.2.4", () => (Promise.all([__webpack_require__.e(925), __webpack_require__.e(950)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-hot-toast", "2.6.0", () => (Promise.all([__webpack_require__.e(925), __webpack_require__.e(768)]).then(() => (() => (__webpack_require__(3768))))));
			register("react-i18next", "16.5.8", () => (Promise.all([__webpack_require__.e(930), __webpack_require__.e(925), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(6930))))));
			register("react-leaflet", "5.0.0", () => (Promise.all([__webpack_require__.e(52), __webpack_require__.e(925), __webpack_require__.e(191), __webpack_require__.e(224)]).then(() => (() => (__webpack_require__(1052))))));
			register("react-router-dom", "7.13.1", () => (Promise.all([__webpack_require__.e(140), __webpack_require__.e(925), __webpack_require__.e(191)]).then(() => (() => (__webpack_require__(2140))))));
			register("react", "19.2.4", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("recharts", "3.8.0", () => (Promise.all([__webpack_require__.e(698), __webpack_require__.e(925), __webpack_require__.e(191)]).then(() => (() => (__webpack_require__(9698))))));
			register("sockjs-client", "1.6.1", () => (__webpack_require__.e(81).then(() => (() => (__webpack_require__(5081))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};